import { DEFAULT_DATE_LOCALE } from '@lumapps/constants';

import { logException } from '../log/logException';

export interface GetDateInSpecificTimeZoneOptions {
    /** current user's language */
    language?: string;
    /** date in string format. Needs to be in UTC */
    date: string;
    /** timezone to convert the date into */
    timeZone: string;
    /** Intl date time format options */
    options?: Intl.DateTimeFormatOptions;
}

/**
 * Displays a timestamp in a selected timezone
 * @param GetDateInSpecificTimeZoneOptions
 * @returns string
 */
export const getDateInSpecificTimezone = ({
    language = DEFAULT_DATE_LOCALE,
    date,
    timeZone,
    options,
}: GetDateInSpecificTimeZoneOptions) => {
    try {
        const dateTimeFormatOptions = options || {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZoneName: 'longOffset',
            hour: '2-digit',
            minute: '2-digit',
        };

        const dateInTimezone = new Date(date).toLocaleDateString(language, { ...dateTimeFormatOptions, timeZone });

        return dateInTimezone;
    } catch (excp) {
        logException(excp);
    }

    return '';
};
